<div class="col-md-12 eip-pl-0 eip-pr-0  eip-pb-10" style="    border-bottom: 1px solid #e1d9d9">
  <div class="container material-cart-container">
    <div class="row">
      <div class="material-list-right  col-md-6 cart-border">
        <div class="material-cart">
          <div class="material-cart-box">
            <div class="row">
              <div class="col-md-12">
                <p class="ff-2 fs-14">Choose Items</p>
              </div>
              <div class="col-md-10">
                <mat-form-field class="example-full-width job-cart-search">
                  <input *ngIf="SearchLength > 0" matInput [placeholder]="Search" aria-label="Job Cart"
                    #strSearchTextInput1 [(ngModel)]='leftSearchValue' autocomplete="off"
                    (ngModelChange)="filterExistingRecords();" (blur)="searchLeftCart()">
                  <input *ngIf="SearchLength == 0" matInput [placeholder]="Search" aria-label="Job Cart"
                    #strSearchTextInput [(ngModel)]='leftSearchValue' autocomplete="off"
                    (ngModelChange)='searchLeftCart(); '>
                </mat-form-field>
              </div>
              <div class="col-md-2 align-self-center p-0 cart-left">
                <div class="btn-group">
                  <button class="btn btn-default job-selector" (click)='moveSelectedItems()' title='Select'
                    [disabled]='_selectArrowModel.isLeftDisabled'>
                    <i class="fa fa-angle-right font-weight-bold"></i></button>
                  <button class="btn btn-default job-selector" title="Select all" (click)='moveAllItems()'
                    [disabled]='_selectArrowModel.isLeftAllDisabled'>
                    <i class="fa fa-angle-double-right font-weight-bold"></i></button>
                </div>
              </div>
            </div>
            <kendo-treeview [nodes]="cartCollection" [textField]="text" kendoTreeViewExpandable kendoTreeViewSelectable
              kendoTreeViewHierarchyBinding childrenField="memberList" *ngIf="addTabVal==0" class=""
              (selectionChange)='getCartItems($event, "left")' dense [isSelected]='selected'>
              <ng-template kendoTreeViewNodeTemplate let-dataItem let-index="index" class="edit-hover">
                {{dataItem.text}}
                <div class="eip-pt-10 edit-hover flex-grow-1 text-right eip-mt-2" *ngIf="dataItem.memberList!=null">
                  <i class="fa fa-pencil eip-mr-10" title="Edit" (click)="editMessageGroup(dataItem)"></i>
                  <i class="fa fa-trash eip-mr-10" title="Delete" (click)="deleteMessageGroup(dataItem)"></i>
                </div>
              </ng-template>         
            </kendo-treeview>
            <mat-selection-list (selectionChange)='getCartItems($event, "left")' dense *ngIf="addTabVal==1">
              <mat-list-option class="material-list-options" *ngFor="let items of cartCollection" [value]='items.value'
                [id]='items.value' (dblclick)='moveItems(items.value, "left")' [title]='items.text'
                [selected]='items.selected'>
                {{items.text}}
              </mat-list-option>
            </mat-selection-list>
          </div>

        </div>
      </div>
      <div class="material-list-right  col-md-6">
        <div class="material-cart">
          <div class="material-cart-box">
            <div class="row">
              <div class="col-md-12">
                <p class="ff-2 fs-14">Selected Items</p>
              </div>
              <div class="col-md-2 align-self-center">
                <div class="btn-group">
                  <button class="btn btn-default job-selector" (click)='removeAllItems()' title='Unselect all'
                    [disabled]='_selectArrowModel.isRightAllDisabled'>
                    <i class="fa fa-angle-double-left font-weight-bold"></i>
                  </button>
                  <button class="btn btn-default job-selector " title="select all" (click)='removeSelectedItems()'
                    title='Unselect' [disabled]='_selectArrowModel.isRightDisabled'><i
                      class="fa fa-angle-left font-weight-bold"></i></button>
                </div>
              </div>
              <div class="col-md-10 eip-pr-0">
                <mat-form-field class="example-full-width job-cart-search">
                  <input matInput placeholder="Search..." aria-label="Job Cart" autocomplete="off"
                    [(ngModel)]='rightSearchValue' (ngModelChange)='searchRightCart()'>
                </mat-form-field>
              </div>
            </div>
            <mat-selection-list (selectionChange)='getCartItems($event, "right")' dense>
              <mat-list-option class="material-list-options" *ngFor="let items of cartSelectedCollection"
                (dblclick)='moveItems(items.value, "right")' [id]='items.value' [value]='items.value'
                [title]="items.text" [selected]='items.selected'>
                {{items.text}}
              </mat-list-option>
            </mat-selection-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="eip-mt-10 eip-mr-20">
  <form [formGroup]="mGForm">
    <div class="row justify-content-end flex-grow-1" *ngIf="addTabVal==1">
      <mat-form-field>
        <input matInput placeholder="Enter Name" formControlName="txtGroupName" required>
        <mat-error *ngIf="mGForm.get('txtGroupName').touched && mGForm.get('txtGroupName').hasError('required')">
          Group Name is required
        </mat-error>
      </mat-form-field>
      <button class="btn btn-primary" id="btnSave" (click)="saveMessageGroup()">Save</button>
    </div>
  </form>
  <div class="row justify-content-end flex-grow-1" *ngIf="addTabVal==0">
    <button class="btn btn-primary" id="btnPost" type="submit" [disabled]="cartSelectedCollection.length == 0"
     (click)="postMessageGroup()">Post</button>
  </div>
</div>